import React, { useEffect, useState } from 'react';
import Routes from './routes';
import 'globalstyles/helpclasses.scss';
import 'globalstyles/normalize.scss';
import 'globalstyles/main.scss';
import 'styles/index.scss';
import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import FormErrorHandler from '@hubins/components/FormErrorHandler';
import { LoadingBox } from '@hubins/components/LoadingIndicators';
import { MiddlemanProvider } from '@hubins/middleman';
import Sidebar from 'components/Sidebar';
import UiProvider from 'components/UiContext';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import svLocale from 'i18n-iso-countries/langs/sv.json';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

countries.registerLocale(enLocale);
countries.registerLocale(svLocale);

import NotificationContext from '@hubins/components/NotificationContext/NotificationContext';

const App = () => {
  const queryClient = new QueryClient();

  const [theBook, setTheBook] = useState(false);
  const [loading, setLoading] = useState(true);

  const init = async () => {
    try {
      const growthbook = new GrowthBook({
        enableDevMode: false,
        apiHost: import.meta.env.VITE_GROWTHBOOK_API_HOST,
        clientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
      });
      await growthbook.init();
      setTheBook(growthbook);
      setLoading(false);
    } catch (error) {
      console.error('Failed to initialize GrowthBook:', error);
      // Create a fallback GrowthBook instance
      const fallbackGrowthbook = new GrowthBook({
        enableDevMode: false,
      });
      setTheBook(fallbackGrowthbook);
      setLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, []);

  if (loading || !theBook) return <LoadingBox />;

  return (
    <Router>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <GrowthBookProvider growthbook={theBook}>
            <MiddlemanProvider baseUrl={import.meta.env.VITE_MIDDLEMAN_URL}>
              <UiProvider>
                <NotificationContext>
                  <FormErrorHandler>
                    <Routes />
                    <Sidebar />
                  </FormErrorHandler>
                </NotificationContext>
              </UiProvider>
            </MiddlemanProvider>
          </GrowthBookProvider>
        </QueryClientProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
